import { render, staticRenderFns } from "./SubmitManually.vue?vue&type=template&id=45c6a58d&"
import script from "./SubmitManually.vue?vue&type=script&lang=js&"
export * from "./SubmitManually.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports